import React, { useEffect } from 'react';
import classnames from 'classnames';
import DaApp from '@wix/da-shared-react/pkg/DaApp';
import SiteHeader from '@wix/da-shared-react/pkg/SiteHeader';
import { RuntimeEnvironment } from '@wix/da-shared-react/pkg/types';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import SiteFooter from '@wix/da-shared-react/pkg/SiteFooter';
import DrawerLoadable from '@wix/da-feedback-shared/pkg/Drawer/DrawerLoadable';
import FeedbackPageLoadable from '@wix/da-feedback-shared/pkg/FeedbackPage/FeedbackPageLoadable';
import { composeModalRenderers } from '@wix/da-shared-react/pkg/Modals/helpers';
import { adoptsModalRenderer } from '@wix/da-adopts-shared/pkg/project-tools';
import { submitModalRenderer } from '@wix/da-submit-shared/pkg/project-tools';
import CommentPage from '../CommentPage';

import s from './App.scss';

export interface Props {
  language: string;
  environment?: RuntimeEnvironment;
  isEmbed?: boolean;
  appLoaded: () => void;
}

const App: React.FC<Props> = ({
  language,
  environment,
  isEmbed,
  appLoaded,
}) => {
  useEffect(() => {
    appLoaded();
  }, [appLoaded]);

  const appProps = {
    language,
    environment,
    ncContextProps: {
      PageComponent: FeedbackPageLoadable,
      DrawerComponent: DrawerLoadable,
    },
  };

  if (isEmbed) {
    // just the basics for embeds and forced light theme
    return (
      <DaApp
        disableHeadTags
        {...appProps}
        bodyClassName={classnames('basic', s['embed'])}
        theme={ThemeOptions.LIGHT}
      >
        <CommentPage isInfinite />
      </DaApp>
    );
  }

  return (
    <DaApp
      {...appProps}
      modalsRenderFunc={composeModalRenderers(
        adoptsModalRenderer,
        submitModalRenderer
      )}
      bodyClassName={s['root']}
      disableHeadTags
    >
      <div className={s['header']}>
        <SiteHeader />
      </div>
      <CommentPage isCanonical />
      <SiteFooter />
    </DaApp>
  );
};

export default App;
